import React, { Component } from 'react';


class Header extends Component {

    render() {
        const { title } = this.props;
        return (
            <tr>
                <td style={{ position: 'relative', height: '96px' }}>
                    <img src="/assets/report-icons/header-img.png" alt="" style={{ position: 'absolute', top: 0, width: '100%', left: 0, zIndex: -1 }} />
                    <img src="/assets/report-icons/logo.png" alt="" style={{ height: '38px', position: 'absolute', top: 0 }} />
                    <span style={{ position: 'absolute', top: '8px', color: '#fff', fontSize: '16px', fontWeight: 550, marginLeft: '60px' }}>
                        {title}
                    </span>
                </td>
            </tr>
        )
    }
}

export default Header;